import { getPageById, routeForPageId } from '../../layouts/menuData.js';
import { OPERATOR_HOME, isOperatorRole } from '../../config/routeAccess.js';

// Role -> landing page id (from the sign-in design reference). Routes resolve by slug;
// a landing page that is not built yet resolves to the generic /404 page.
const ROLE_LANDING_PAGE_IDS = {
  Supervisor: 73915,
  Manager: 73923,
  Worker: 73920,
  Technician: 73920,
  Raiser: 73912,
  Admin: 73923,
  admin: 73923,
  'Customer Admin': 73923,
  'Service Desk Agent': 73913,
  'Provider Admin': 73918,
  Finance: 73930,
  Auditor: 73924,
  'Any User': 73912,
};

// (role may be the access role from config/routeAccess.js: 'Platform Admin' lands on the page it can use.)
export function landingRouteForRole(role) {
  if (role === 'Platform Admin') return '/role-permissions-security-policies';
  // The Xamun Operator has no tenant page: the console is a direct route, not a page id.
  if (isOperatorRole(role)) return OPERATOR_HOME;
  const pageId = ROLE_LANDING_PAGE_IDS[role] ?? 73923;
  return getPageById(pageId) ? routeForPageId(pageId) : '/404';
}
